<template>
  <table class="table table-sm color">
    <caption class="caption table-caption">{{caption}} Results</caption>
    <tbody>
      <tr>
        <th class="text-left font-weight-normal">{{type}}</th>
        <td class="text-right">{{result}}</td>
      </tr>
      <tr>
        <th class="text-left font-weight-normal">WAL</th>
        <td class="text-right">{{wal}}</td>
      </tr>
      <tr>
        <th class="text-left font-weight-normal">{{windowLabel}}</th>
        <td class="text-right">{{principalWindow}}</td>
      </tr>
      <tr>
        <th class="text-left font-weight-normal">Write Down</th>
        <td class="text-right">{{writedownPct}}</td>
      </tr>
      <tr>
        <th class="text-left font-weight-normal">First Loss Period</th>
        <td class="text-right">{{firstLossPeriod}}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["caption", "type", "result", "wal", "principalWindow", "writedownPct", "firstLossPeriod"],
  computed: {
    windowLabel() {
      let windowLabel = 'Principal Window'

      if (this.caption == "CIRT") { windowLabel = 'Loss Window' } else if (this.caption == "ACIS") { windowLabel = 'Reduction In Liability Window' }

      return windowLabel
    }
  }
}
</script>

